import { render, staticRenderFns } from "./wallet_transaction_types.vue?vue&type=template&id=2eae168a&scoped=true&"
import script from "./wallet_transaction_types.vue?vue&type=script&lang=js&"
export * from "./wallet_transaction_types.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eae168a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2eae168a')) {
      api.createRecord('2eae168a', component.options)
    } else {
      api.reload('2eae168a', component.options)
    }
    module.hot.accept("./wallet_transaction_types.vue?vue&type=template&id=2eae168a&scoped=true&", function () {
      api.rerender('2eae168a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/fields/dropdown/wallet_transaction_types.vue"
export default component.exports